import { Function, Type, Task, Talk, Announcement, Note, Consultation } from '../Entities';
import { Post, DummyPlainObject } from './Chat/Post';

export class Functions {
  private functionMap: { [key: string]: Function<Post> } = {};
  private _lastupdate: Date = new Date();

  constructor();
  constructor(_lastupdate: Date);
  public constructor(lastupdate?: any) {
    if (lastupdate != null) {
      this._lastupdate = lastupdate;
    }
  }

  public get lastupdate(): Date {
    return this._lastupdate;
  }

  public update(): void {
    this._lastupdate = new Date();
  }

  public add(func: Function<Post>): void {
    this.functionMap[func.id] = func;
  }

  public get(key: string): Function<Post> {
    return this.functionMap[key];
  }

  public keys(): string[] {
    return Object.keys(this.functionMap);
  }

  public get task(): Function<Post> {
    const self = this;
    const key = this.keys().reduce((before: string, current: string, index: number, arr: string[]) => {
      if (self.get(current) instanceof Task) {
        return current;
      }
      return before;
    });
    return this.get(key);
  }

  public get talk(): Function<Post> {
    const self = this;
    const key = this.keys().reduce((before: string, current: string, index: number, arr: string[]) => {
      if (self.get(current) instanceof Talk) {
        return current;
      }
      return before;
    });
    return this.get(key);
  }

  public get note(): Function<Post> {
    const self = this;
    const key = this.keys().reduce((before: string, current: string, index: number, arr: string[]) => {
      if (self.get(current) instanceof Note) {
        return current;
      }
      return before;
    });
    return this.get(key);
  }

  public get consultation(): Function<Post> {
    const self = this;
    const key = this.keys().reduce((before: string, current: string, index: number, arr: string[]) => {
      if (self.get(current) instanceof Consultation) {
        return current;
      }
      return before;
    });
    return this.get(key);
  }
  
  public get announcement(): Function<Post> {
    const self = this;
    const key = this.keys().reduce((before: string, current: string, index: number, arr: string[]) => {
      if (self.get(current) instanceof Announcement) {
        return current;
      }
      return before;
    });
    return this.get(key);
  }

  public toPlainObject(): Object {
    const plainObject: DummyPlainObject = {};
    Object.keys(this.functionMap).map((key: string) => {
      plainObject[key] = this.functionMap[key].toPlainObject();
    })
    plainObject['lastupdate'] = this.lastupdate;
    return plainObject;
  }
}
